import Vue from "vue";
import Vuex from "vuex";
import users from "@/store/modules/users";
import categories from "@/store/modules/categories";
import attributes from "@/store/modules/attributes";
import mapping from "@/store/modules/mapping";
import {
  SET_LOADING,
  SET_MESSAGE,
  SET_ERROR
} from "@/store/constants/mutation-types";

Vue.use(Vuex);

const state = {
  loading: false,
  message: "",
  error: false
};

const getters = {
  /**
   * @description retourn true ou false pour le loading
   * @returns {boolean}
   */
  isLoading: () => state.loading,
  /**
   * @description retourn true ou false pour le loading
   * @returns {boolean}
   */
  isError: () => state.error
};

const actions = {
  /**
   * @description action qui envoie un Toast success
   * @param commit
   * @param state
   * @param message
   */
  setSuccessToast({ commit, state }, message) {
    commit(SET_MESSAGE, message);
    this._vm.$bvToast.toast(state.message, {
      title: `Success`,
      toaster: "b-toaster-top-center",
      variant: "success",
      solid: true,
      appendToast: false
    });
  },

  /**
   * @description action qui envoie un Toast error
   * @param commit
   * @param state
   * @param message
   */
  setErrorToast({ commit, state }, message) {
    commit(SET_MESSAGE, message);
    this._vm.$bvToast.toast(state.message, {
      title: `Error`,
      toaster: "b-toaster-top-center",
      variant: "danger",
      solid: true,
      appendToast: false
    });
  },

  /**
   * @description action change error a true ou a false
   * @param commit
   * @param bool
   */
  setErrors({ commit }, bool) {
    commit(SET_ERROR, bool);
  }
};

const mutations = {
  /**
   * @description mutation loading
   * @param state
   * @param bool
   */
  [SET_LOADING](state, bool) {
    state.loading = bool;
  },

  /**
   * @description mutation message success
   * @param state
   * @param successMessage
   */
  [SET_MESSAGE](state, successMessage) {
    state.message = successMessage;
  },
  /**
   * @description mutation error
   * @param bool
   */
  [SET_ERROR](state, bool) {
    state.error = bool;
  }
};
export default new Vuex.Store({
  modules: {
    users,
    categories,
    attributes,
    mapping
  },
  state,
  getters,
  actions,
  mutations
});
